import { MessageCircle } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { track } from "../lib/api";

export default function WhatsAppFloat() {
  const { settings } = useSite();
  const wa = `https://wa.me/${settings.whatsapp_number}?text=${encodeURIComponent("Need software today? Ask about Rush Hour.")}`;
  return (
    <a
      href={wa}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp Built2Last"
      data-testid="whatsapp-float-btn"
      onClick={() => track("whatsapp_click", { location: "float" })}
      className="fixed bottom-20 xl:bottom-6 right-5 z-40 w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-400 flex items-center justify-center shadow-[0_8px_30px_rgba(16,185,129,0.45)] transition-transform duration-200 hover:scale-110"
    >
      <MessageCircle className="w-6 h-6 text-white" />
    </a>
  );
}
